const trackGoogleEvent = (eventcategory, eventaction, eventlabel, eventnoninteraction) => {
    window.dataLayer = window.dataLayer || [];

    if (typeof eventcategory === 'object' && !Array.isArray(eventcategory)) {
        window.dataLayer.push(eventcategory);
        return;
    }

    window.dataLayer.push({
        event: "interactionevent",
        ...(eventcategory && { eventcategory }),
        ...(eventaction && { eventaction }),
        ...(eventlabel && { eventlabel }),
        eventnoninteraction: eventnoninteraction && eventnoninteraction.toString() || "false",
    });
};

export default trackGoogleEvent;